import { request as sonataRequest } from 'sonata-react-components';

import type { InsightType } from '../components/menu/Insights/insights.types';

export async function getInsights(userId: string, type: InsightType) {
  const url = `${taptap.config.backendUrlBase}tableau/insightsSnippetConfig/user/${userId}/type/${type}`;
  const data = await sonataRequest.makeRequest(url, {
    method: 'GET'
  });

  return data;
}
